import { email } from '@axo/shared/data-access/types';
import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';

export interface EmailTemplates {
  Items: email.EmailTemplate[];
}

export function findEmailTemplates({ url: { service: baseURL }, token }: IAPI) {
  return async function findEmailTemplates(params: {
    marketCountry: string;
    broker: number;
  }): Promise<EmailTemplates> {
    return send({
      baseURL,
      token,
      path: `/email-communication-template/template?active=true&marketCountry=${params.marketCountry}&broker=${params.broker}`,
      method: 'GET',
    });
  };
}
